export const STATS = [
  {
    title: "Total Players",
    field: "totalVersusUsers",
    color: "primary",
    format: "number",
  },
  {
    title: "H2H Players",
    field: "totalHeadToHeadUsers",
    color: "primary",
    format: "number",
  },
  {
    title: "Season Players",
    field: "totalSeasonUsers",
    color: "primary",
    format: "number",
  },
  {
    title: "Spent",
    field: "totalEntryFee",
    color: "secondary",
    format: "number",
  },
  {
    title: "H2H Spent",
    field: "totalEntryFeeCoins",
    color: "secondary",
    format: "number",
  },
  {
    title: "Season Spent",
    field: "totalSeasonEntryFeeCoins",
    color: "secondary",
    format: "number",
  },
  {
    title: "Total Payouts",
    field: "totalPrize",
    color: "success",
    format: "number",
  },
  {
    title: "H2H Payouts",
    field: "totalGamePrizeCoins",
    color: "success",
    format: "number",
  },
  {
    title: "Season Payouts",
    field: "totalSeasonPrizeCoins",
    color: "success",
    format: "number",
  },
  {
    title: "Total Profit",
    field: "totalProfit",
    color: "warning",
    format: "number",
  },
  {
    title: "H2H Profit",
    field: "headToHeadProfit",
    color: "warning",
    format: "number",
  },
  {
    title: "Season Profit",
    field: "seasonProfit",
    color: "warning",
    format: "number",
  },
  {
    title: "Total Margin",
    field: "totalProfitPct",
    color: "info",
    format: "percent",
  },
  {
    title: "H2H Margin",
    field: "totalHeadToHeadProfitPct",
    color: "info",
    format: "percent",
  },
  {
    title: "Season Margin",
    field: "totalSeasonProfitPct",
    color: "info",
    format: "percent",
  },
  {
    title: "DC Players",
    field: "dailyUsers",
    color: "success",
    format: "number",
  },
  {
    title: "DC Started",
    field: "dailyStarted",
    color: "success",
    format: "number",
  },
  {
    title: "DC Completed",
    field: "dailyCompleted",
    color: "success",
    format: "number",
  },
  {
    title: "DC %",
    field: "dailyCompletedPct",
    color: "success",
    format: "percent",
  },
  {
    title: "Contract Swaps",
    field: "totalSwapsCount",
    color: "success",
    format: "number",
  },
  {
    title: "Swap Coins",
    field: "totalSwapCoints",
    color: "success",
    format: "number",
  },
];
